import { RootState } from "../store";

export const selectUser = (state: RootState) => state.user;

export const selectUserCapabilities = (state: RootState) => state.user.userCapabilities;

export const selectHasAccess = (state: RootState) => state.user.hasAccess;
